// extracted by mini-css-extract-plugin
module.exports = {"create":"course-list_create__8xj4y"};